module.exports = __webpack_public_path__ + "img/dark_willow.6b387b67.png";